<script setup lang="ts">
/* eslint-disable vue/no-v-html */
interface Props {
  content : string | null;
}

defineProps<Props>();
</script>

<template>
  <h2 class="tw-text-2xl tw-text-center tw-mb-8 tw-font-semibold">
    Install authenticator on your mobile device
  </h2>
  <div
    v-if="content"
    v-html="content"
  ></div>
</template>
